import { buildReducer } from '../../utils/redux/getReduxModuleByFeatureName';
import { LOCATION_CHANGE } from 'connected-react-router';
import { matchPath } from 'connected-react-router';
import getConstantsByFeatureName from '../../utils/redux/getConstantsByFeatureName';
import getActionCreators from '../../utils/redux/getActionCreators';
import getActionHandlers from '../../utils/redux/getActionHandlers';
import getSelectorByFeatureName from '../../utils/redux/getSelectorByFeatureName';


const initialState = {
  data: null,
  isLoading: true,
  error: null,
};

export const routeConfig = { path: '/owners/:id/:tab', exact: true };
export const constants = getConstantsByFeatureName('OWNER_DETAILS');
export const actions = getActionCreators(constants);

export const reducer = buildReducer(initialState, {
  ...getActionHandlers(constants),
  [LOCATION_CHANGE]: (state, { payload: { location: { pathname } } }) => (
    matchPath(pathname, routeConfig)
      ? routeConfig
      : initialState
  ),
});

export const selector = getSelectorByFeatureName('ownerDetails');
